import React from 'react'
import { NumericFormat } from 'react-number-format'

import styled from 'styled-components'

import { Box, HelperText, ICONS_NAME, Label, typographyVariants } from '../'

import { InputAdornment } from './components'
import { COLORS } from '@/constants'

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width};
`

const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  border: 1px solid;
  border-radius: 4px;
  background: ${COLORS.whiteHighEmphasis};
  height: 30px;
  min-height: 30px;

  // Default padding
  padding: 0 10px;
  &[data-size='small'] {
    min-height: 25px;
  }

  &[data-size='normal'] {
    min-height: 35px;
  }

  &[data-size='big'] {
    min-height: 45px;
  }

  // Default state
  border-color: ${COLORS.blackDisabled};
  color: ${COLORS.blackDisabled};

  &:focus-within {
    border-color: ${COLORS.primary500};
    box-shadow: 0 4px 7px rgba(157, 173, 184, 0.2);
  }

  // Error state
  ${({ $isError }) =>
    $isError &&
    `border-color: ${COLORS.errorLight} !important;
     // color: ${COLORS.errorLight} !important;
    
  `}

  // Disabled state
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    border-color: ${COLORS.grayInactive} !important;
    box-shadow: none !important;
    color: ${COLORS.grayInactive} !important;
  `}
  
  // ReadOnly state
  ${({ $isReadOnly }) =>
    $isReadOnly &&
    `box-shadow: none !important;
     color: ${COLORS.blackDisabled} !important;
     
     &:focus-within {
     border-color: ${COLORS.blackDisabled} !important;
     box-shadow: none !important;
     }
    }
  `}
`

const InputElement = styled.input`
  width: 100%;
  border: 0;
  margin: 0;
  padding: 0 5px;
  outline: none;

  font-size: ${typographyVariants.body1.fontSize};
  line-height: ${typographyVariants.body1.lineHeight};
  font-weight: ${typographyVariants.body1.fontWeight};

  // Default state
  color: ${COLORS.blackHighEmphasis};
  &::placeholder {
    color: ${COLORS.blackDisabled};
  }

  // Cursor pointer for date type
  ${({ type }) =>
    type === 'date' &&
    `
    cursor: pointer;
  `}

  // Error state
    ${({ $isError }) =>
    $isError &&
    `
    &::placeholder {
      color: ${COLORS.blackDisabled};
    }
  `}

        // Disabled state
    ${({ $isDisabled }) =>
    $isDisabled &&
    `color: inherit;
    &::placeholder {
      color: inherit;
    }
  `}

        // ReadOnly state
    ${({ $isReadOnly }) =>
    $isReadOnly &&
    `color: inherit;
     cursor: not-allowed;
     
    &::placeholder {
      color: inherit;
    }
  `}
`


const InputV2 = ({
    width = '100%',
    type = 'text',
    name,
    label,
    placeholder,
    value,
    autoComplete = 'off',
    isRequired = false,
    isDisabled = false,
    isAutoFocus = false,
    isReadOnly = false,
    isError = false,
    rightAdornment,
    leftAdornment,
    helperText,
    onChange = () => {},
    onBlur,
    onClick,
    onEnter,
    refInput,
    size = 'normal',
    decimalScale = 0,
                            }) => {
    const onFloatValueChange = (floatValue) => onChange(floatValue)

    return (
        <OuterContainer width={width} onClick={onClick}>
            {/* Label */}
            {label && (
                <Label label={label} isRequired={isRequired} isDisabled={isDisabled} />
            )}

            <InputContainer
                $isReadOnly={isReadOnly}
                $isDisabled={isDisabled}
                $isError={isError}
                data-size={size}
            >
                <InputAdornment>{leftAdornment}</InputAdornment>

                {/* Input */}
                {type === 'number' ? (
                    <NumericFormat
                        type="text"
                        thousandSeparator=","
                        allowedDecimalSeparators={['.', ',']}
                        decimalScale={decimalScale}
                        fixedDecimalScale
                        customInput={InputElement}
                        onValueChange={values => onFloatValueChange(Number(values.value))}
                        data-size={size}
                        name={name}
                        data-name={name}
                        placeholder={placeholder}
                        value={value}
                        disabled={isDisabled}
                        readOnly={isReadOnly}
                        $isReadOnly={isReadOnly}
                        $isDisabled={isDisabled}
                        $isError={isError}
                        onBlur={onBlur}
                        autoFocus={isAutoFocus}
                    />
                ) : (
                    <InputElement
                        data-size={size}
                        type={type}
                        name={name}
                        data-name={name}
                        placeholder={placeholder}
                        value={value}
                        disabled={isDisabled}
                        readOnly={isReadOnly}
                        $isReadOnly={isReadOnly}
                        $isDisabled={isDisabled}
                        $isError={isError}
                        onChange={value => onChange(value)}
                        onBlur={onBlur}
                        autoFocus={isAutoFocus}
                        autoComplete={autoComplete}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' && onEnter) {
                                onEnter()
                            }
                        }}
                        ref={refInput}
                    />
                )}

                {rightAdornment && (
                    <Box width="250px" display="flex" justify="right">
                        <InputAdornment>{rightAdornment}</InputAdornment>
                    </Box>
                )}
            </InputContainer>

            {/* Helper message or error message*/}
            {helperText && <HelperText text={helperText} isError={isError} />}
        </OuterContainer>
    )
}

export { InputV2 }
